import React from 'react'
import { Grid,  Typography } from "@mui/material";



const Empty = () => {

    return (
        <React.Fragment>
                <Grid>
                        <Typography>Fermi versao 2.</Typography>
                </Grid>
        </React.Fragment>
    )
}



export default (Empty);

